/**
 * Link de pular navegação — invisível até receber foco.
 * Quem navega por teclado não precisa passar pelos 5 itens do menu em toda
 * página para chegar ao conteúdo.
 */
export function PularParaConteudo() {
  return (
    <a
      href="#conteudo"
      className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[100] focus:rounded-lg focus:bg-brand-600 focus:px-4 focus:py-2 focus:font-semibold focus:text-white"
    >
      Pular para o conteúdo
    </a>
  )
}
